import GenericError from '@/presentation/components/ui/feedback/generic-error'
import { Await, useLoaderData } from 'react-router-dom'
import { historyStateParams } from './url-helper'

type PathAwaitProps = {
  children: JSX.Element
  errorElement?: React.ReactNode
}

export default function PathAwait<PageLoaderDataModel>({ children, errorElement }: PathAwaitProps) {
  const loader = useLoaderData() || { data: () => null }
  const { data } = loader as { data: Promise<PageLoaderDataModel> }
  return (
    <Await resolve={data} errorElement={errorElement ?? <GenericError fullScreen />}>
      {children}
    </Await>
  )
}

export function PathAwaitGenericReloadError({ children }: Omit<PathAwaitProps, 'errorElement'>) {
  return (
    <PathAwait
      errorElement={
        <GenericError
          fullScreen
          onReloadClick={() => {
            historyStateParams()
            window.location.reload()
          }}
        />
      }
    >
      {children}
    </PathAwait>
  )
}
